import { render } from "./OfficialSection.vue?vue&type=template&id=4d0edc16&scoped=true"
const script = {}

import "./OfficialSection.vue?vue&type=style&index=0&id=4d0edc16&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LEGION\\Desktop\\SONNAR\\proiBueno\\virgen\\reppsoc-ppqy9-portaltuturesweb\\reppsoc-ppqy9-portaltuturesweb\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0edc16"]])

export default __exports__